// Admin'den manuel toplu push gonderim DTO'lari.
import { z } from 'zod';
export const promosyonPushFiltresi = z.object({
    dil: z.enum(['tr', 'en']).optional(),
    sonGirisGunIcinde: z.number().int().min(1).max(365).optional(),
    musteriIdler: z.array(z.string().cuid()).max(10_000).optional(),
});
export const promosyonPushIstegi = z.object({
    filtre: promosyonPushFiltresi,
    baslik: z.string().min(2).max(120),
    govde: z.string().min(2).max(500),
    veri: z.record(z.string(), z.string()).optional(),
});
//# sourceMappingURL=promosyon-push.js.map